import React from "react";
import PropTypes from "prop-types";

/*

This is a higher order component intended to wrap a timeseries type of component
since, regardless of implementation, most graph/chart libraries will take a bit of time
to render large datasets, this component will first render the desired timeseries with
an empty dataset, that way, the user could (if the timeseries is properly coded) see some
of the chart's parts, like the axes, legends, background, and then will start to render
the full dataset, resulting in a better UX.

The wrapped component (via the prop 'chart') should use the 'data' prop as its datasource
all other props will bypass this HOC and should be available for the wrapped component

If the data payload is small, this HOC will skip trying do a quick rende rand simply render
it normally, for now, the quantity of elements we consider small is hardcoded in the constant
'LITTLE_DATA', it could be a prop, but I don't want to clutter the files where its used,
for our use case, it should be good enough in all cases.

*/

class SmartTimeSeriesRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { skipQuickRender: false };
  }

  componentWillMount() {
    // Usually, a day's worth of Fuel data is around 1440 objects (1 per minute)
    const LITTLE_DATA = 2000;

    if (this.props.data.length < LITTLE_DATA) {
      this.setState({ skipQuickRender: true });
    } else if (!this.state.skipQuickRender) {
      // We should only do a quick render once
      // If we do a timeout, the component will finish the initial quick render
      // before changing state and performing a full render
      setTimeout(() => {
        this.setState({ skipQuickRender: true });
      }, 10);
    }
  }

  render() {
    let { data, ...other } = this.props;
    const ChartComponent = this.props.chart;

    // If the component has already done the quick render or has a small amount of data, do a full render
    if (this.state.skipQuickRender) {
      return <ChartComponent data={data} {...other} />;
    } else {
      // Otherwise, lets do a quick render with no data so the user sees something ASAP
      return <ChartComponent data={[]} {...other} />;
    }
  }
}

SmartTimeSeriesRenderer.propTypes = {
  data: PropTypes.array.isRequired
};

export default SmartTimeSeriesRenderer;



// WEBPACK FOOTER //
// ./src/charts/SmartTimeSeriesRenderer/index.js